import { createReducerContext } from '../../../../utils/create-reducer-context';
import { ACTION_TYPES, SubmissionSendReducer, createInitialState } from './submission-send-reducer';

const { Provider: SubmissionSendProvider, useStateContext: useSubmissionSendState, useDispatchContext: useSubmissionSendDispatch } =
    createReducerContext('SubmissionSend', SubmissionSendReducer, createInitialState());

export { SubmissionSendProvider, useSubmissionSendState, useSubmissionSendDispatch, ACTION_TYPES };
